import React from 'react'
import cn from 'classnames'
import {
  Button,
  type ButtonKindValue,
  type ButtonProps,
  type ButtonSizeValue,
} from '@mc/design-system'
import { HighlightedArrow } from '../HighlightedArrow'

type HighlightedArrowProps = React.ComponentProps<typeof HighlightedArrow>

export type ArrowCtaProps = ButtonProps & {
  arrowTheme?: HighlightedArrowProps['theme']
  arrowSize?: HighlightedArrowProps['size']
}

const DARK_ARROW_KINDS: ReadonlyArray<ButtonKindValue> = [
  'accent',
  'primary-accent',
  'tertiary',
]

const TIGHT_GAP_SIZES: ReadonlyArray<ButtonSizeValue> = ['xs', 'sm', 'small']

export const ArrowCta = React.forwardRef<HTMLButtonElement, ArrowCtaProps>(
  (
    {
      children,
      className,
      kind = 'primary',
      size = 'md',
      arrowTheme,
      arrowSize,
      ...props
    },
    ref,
  ) => (
    <Button
      ref={ref}
      kind={kind}
      size={size}
      className={cn(
        TIGHT_GAP_SIZES.includes(size) ? 'gap-2' : 'gap-3',
        className,
      )}
      {...props}
    >
      {children}
      <HighlightedArrow
        theme={
          arrowTheme ??
          (DARK_ARROW_KINDS.includes(kind) ? 'dark' : 'highlighted')
        }
        size={arrowSize}
      />
    </Button>
  ),
)

ArrowCta.displayName = 'ArrowCta'
